import { colors } from '@cimpress/react-components';
import { css } from '@emotion/react';
export const displayFieldName = css `
    font-weight: bold;
    margin-top: 5px;
`;
export const displayFieldValue = css `
    margin-top: 5px;
`;
export const displayFieldDiv = css `
    align-items: center;
    margin-top: 5px;
`;
export const detailsHeader = css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    gap: 10px;
    background-color: ${colors.horizon};
    margin-top: 5px;

    & .si-f-title {
        color: rgb(128, 144, 162);
        margin-bottom: 10px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        display: block;
    }
`;
export const cssBack = css `
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
    font-weight: 700;
    & svg {
        padding-top: 5px;
        margin-bottom: 4px;
    }
`;
export const cssDetailsSection = css `
    border: 1px solid ${colors.horizon};
    padding: 10px;
`;
export const cssFlexLeft = css `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`;
export const cssDetailsRow = css `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
`;
export const marginBottom25 = css `
    margin-bottom: 25px;
`;
